import type { OptionsProps } from '@/components/atoms/select/Select';

const residenceTypesOptions: OptionsProps[] = [
  { value: 'house', label: 'Casa' },
  { value: 'apartment', label: 'Apartamento' },
  { value: 'condo_house', label: 'Casa de Condomínio' },
  { value: 'country_house', label: 'Chácara' },
  { value: 'pent_house', label: 'Cobertura' },
  { value: 'studio', label: 'Flat / Kitnet' },
];

export default residenceTypesOptions;
